export default defineNuxtPlugin(() => {
  if (process.client) {
    let isTauri = false
    let dbReady = false

    import('@tauri-apps/api/core').then(async ({ invoke }) => {
      try {
        await invoke('get_device_type')
        isTauri = true
        console.log('[Console Logger] Tauri detected, intercepting console methods')
        interceptConsole()
      } catch {
        console.log('[Console Logger] Not in Tauri environment, skipping log file writing')
      }
    }).catch(() => {})

    const waitForDb = async () => {
      if (dbReady) return true
      try {
        const { usePosDatabase } = await import('~/composables/usePosDatabase.js')
        const { isDbReady } = usePosDatabase()
        if (isDbReady.value) {
          dbReady = true
          return true
        }
      } catch {}
      return false
    }

    const writeToSqlite = async (level, component, message) => {
      try {
        if (!await waitForDb()) return
        const { usePosDatabase } = await import('~/composables/usePosDatabase.js')
        const { saveAppLog } = usePosDatabase()
        await saveAppLog(level, component, message)
      } catch {}
    }

    function interceptConsole() {
      const original = {
        log: console.log,
        info: console.info,
        warn: console.warn,
        error: console.error
      }

      const writeToTauri = async (level, args) => {
        try {
          const { invoke } = await import('@tauri-apps/api/core')
          const message = args.map(arg =>
            typeof arg === 'object' ? JSON.stringify(arg) : String(arg)
          ).join(' ')

          await invoke('write_app_log', {
            level,
            component: 'console',
            message,
            timestamp: new Date().toISOString()
          })

          writeToSqlite(level, 'console', message)
        } catch (err) {
        }
      }

      console.log = function(...args) {
        original.log.apply(console, args)
        if (isTauri) writeToTauri('DEBUG', args)
      }

      console.info = function(...args) {
        original.info.apply(console, args)
        if (isTauri) writeToTauri('INFO', args)
      }

      console.warn = function(...args) {
        original.warn.apply(console, args)
        if (isTauri) writeToTauri('WARN', args)
      }

      console.error = function(...args) {
        original.error.apply(console, args)
        if (isTauri) writeToTauri('ERROR', args)
      }
    }
  }
})
